import Icon from 'components/shared/Icon';
import Lock from 'components/shared/Icon/icons/NewLock';

import s from '../index.module.css';
import { ContactLink } from './ContactLink';

export const FlightSearchLock = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className={s.blocker}>
      <Icon component={Lock} className={s.lockIcon} />
      <div className={s.blockerTitle}>Automatic Flight Search Locked</div>
      <div>Please contact sales to upgrade to a Tier II plan</div>
      <div>
        or{' '}
        <span className={s.blockLink} onClick={onClick}>
          Add flights manually
        </span>
      </div>
      <ContactLink />
    </div>
  );
};
